import karmaEarnOfferSlice from './slice';

export default karmaEarnOfferSlice.reducer;
